import { render, staticRenderFns } from "./menu3060_3.vue?vue&type=template&id=4eb12c51&scoped=true&"
import script from "./menu3060_3.vue?vue&type=script&lang=js&"
export * from "./menu3060_3.vue?vue&type=script&lang=js&"
import style0 from "./menu3060_3.vue?vue&type=style&index=0&id=4eb12c51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb12c51",
  null
  
)

export default component.exports